import Router from "@services/router"
import ActivityPage from "./components/pages/Activity"
import AwardsPage from "./components/pages/Awards/AwardsPage"
import CustomersPage from "./components/pages/Customers"
import JuriesPage from "./components/pages/Juries"
import OrganizationsPage from "./components/pages/Organizations"
import SalonConditionsPage from "./components/pages/Salon/Conditions/SalonConditionsPage"
import SalonCustomersPage from "./components/pages/Salon/Customers"
import SalonEditPage from "./components/pages/Salon/Edit"
import SalonGalleryPage from "./components/pages/Salon/Gallery/SalonGalleryPage"
import SalonGeneralPage from "./components/pages/Salon/General/SalonGeneralPage"
import SalonJuriesPage from "./components/pages/Salon/Juries"
import SalonPaymentsPage from "./components/pages/Salon/Payments"
import SalonPromocodesPage from "./components/pages/Salon/Promocodes"
import SalonTrackingPage from "./components/pages/Salon/Tracking/SalonTrackingPage"
import SalonsPage from "./components/pages/Salons/SalonsPage"
import SectionsPage from "./components/pages/Sections"
import UserPage from "./components/pages/User"
import SalonManagerTemplate from "./components/templates/SalonManager"

export default [
    Router.page({ name: ["admin", "admin:salons"], path: "/app/admin/salons", component: SalonsPage }),
    Router.page({ name: "admin:customers", path: "/app/admin/customers", component: CustomersPage }),
    Router.page({ name: "admin:user", path: "/app/admin/users/:id", component: UserPage }),
    Router.page({ name: "admin:juries", path: "/app/admin/juries", component: JuriesPage }),
    Router.page({ name: "admin:organizations", path: "/app/admin/organizations", component: OrganizationsPage }),
    Router.page({ name: "admin:sections", path: "/app/admin/sections", component: SectionsPage }),
    Router.page({ name: "admin:awards", path: "/app/admin/awards", component: AwardsPage }),
    Router.page({ name: "admin:logs", path: "/app/admin/logs", component: ActivityPage }),
    Router.page({ name: "admin:salons:add", path: "/app/admin/salons/add", component: SalonEditPage }),
    Router.page({ name: "admin:salons:edit", path: "/app/admin/salons/:id/edit", component: SalonEditPage }),

    Router.group({ template: SalonManagerTemplate }, [
        Router.page({ name:"admin:salon", path: "/app/admin/salons/:id", component: SalonGeneralPage }),
        Router.page({ name:"admin:salon:customers", path: "/app/admin/salons/:id/customers", component: SalonCustomersPage }),
        Router.page({ name:"admin:salon:gallery", path: "/app/admin/salons/:id/gallery", component: SalonGalleryPage }),
        Router.page({ name:"admin:salon:juries", path: "/app/admin/salons/:id/juries", component: SalonJuriesPage }),
        Router.page({ name:"admin:salon:payments", path: "/app/admin/salons/:id/payments", component: SalonPaymentsPage }),
        Router.page({ name:"admin:salon:promocodes", path: "/app/admin/salons/:id/promocodes", component: SalonPromocodesPage }),
        Router.page({ name:"admin:salon:tracking", path: "/app/admin/salons/:id/tracking", component: SalonTrackingPage }),
        Router.page({ name:"admin:salon:conditions", path: "/app/admin/salons/:id/conditions", component: SalonConditionsPage }),
    ])
]